import { useEffect, useState } from 'react';
import { getToken } from '../utils';
import axios from 'axios';
import AdsCarousel from './AdsCarousel';

export const AddAds = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [adverts, setAdverts] = useState([]);

  const { token: userToken } = getToken();
  useEffect(() => {
    setIsLoading(true);
    const getAdverts = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/adverts`,
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        setAdverts(response.data);
      } catch (error) {
        console.log(error, 'error in lv account');
      } finally {
        setIsLoading(false);
      }
    };

    getAdverts();
  }, [userToken]);

  // console.log(adverts);
  return (
    <div className='w-full h-[184px] flex justify-center items-center text-center bg-p-wh  overflow-hidden rounded-md '>
      {isLoading ? (
        'Loading ads...'
      ) : (
        <AdsCarousel authCarouselItems={adverts} />
      )}{' '}
    </div>
  );
};
